"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const request_1 = require("../requests/request");
class API {
    /**
     * Fetches the user's create
     * @returns {Promise<Media[]>} The Promise contains an APIError if rejected
     */
    static getCrate() {
        let apiRequest = new request_1.AuthenticatedRequest('/crate', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.Media).then((response) => {
            return response.data;
        });
    }
    /**
 * @returns {Promise<{id: string}>} The Promise contains an APIError if rejected
 */
    static getCrateDownloadId(type, category, overrideAPIUrl, idempotentToken) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/download', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { type, category, idempotentToken });
        apiRequest.overrideAPIUrl = overrideAPIUrl;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
        * @returns {Promise<[]>} The Promise contains an APIError if rejected
    */
    static clearCrate(type, category) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate', request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2, { type, category });
        return apiRequest.send(models_1.Media).then((response) => {
            return response.data;
        });
    }
    /**
     * @returns {Promise<{id: string}>} The Promise contains an APIError if rejected
     */
    static getCrateDownloadLink(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/download/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static addToCrate(media_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/' + media_id, request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        apiRequest.preventNotVerifiedHandler = true;
        apiRequest.preventInvalidSubscriptionHandler = true;
        return apiRequest.send(models_1.Media).then((response) => {
            return response.data;
        });
    }
    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static addPlaylistToCrate(playlist_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/playlist/' + playlist_id, request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static addSetPlaylistToCrate(set_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/curated_set/' + set_id, request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Removes from the user's create
     * @returns {Promise<Media[]>} The Promise contains an APIError if rejected
     */
    static removeFromCrate(media_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/crate/' + media_id, request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/crate.js
// module id = 959
// module chunks = 0